/* eslint-disable camelcase */
import React from "react";
import cn from "classnames";

import { Text, SearchFilter } from "@themuse/design-system";

import { FacetProps, getFacetProps } from "utils/searchFacets";
import { useSearchFacetsState } from "hooks/SearchFacetsContext";
import {
    companySizeItems,
    convertToFacetItemsFormat,
    convertPerksAndBeniftsToNestedFormat,
} from "utils/searchFacetItems";

import styles from "../SearchFacets.module.scss";

const CompanyFacets = (props: FacetProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { companyFacets } = useSearchFacetsState();
    const { industries, perks_and_benefits, diversity_and_inclusion_attributes } = companyFacets;

    return (
        <div className={styles.companyFilterSection}>
            <header className={styles.header}>
                <Text
                    htmlTag="h2"
                    textStyle="heading-3"
                    className={cn(styles.headerText, styles.subHeaderText)}
                >
                    Company Filters
                </Text>
            </header>
            <div className={styles.facetList}>
                <SearchFilter {...getFacetProps({
                    ...props,
                    fieldType: "checkbox",
                    disableOnCompanySelect: true,
                    userInputFilterName: "industry",
                    searchFilterItems: convertToFacetItemsFormat(industries),
                    labelText: "Company Industry"
                })}
                />
                <SearchFilter {...getFacetProps({
                    ...props,
                    fieldType: "checkbox",
                    disableOnCompanySelect: true,
                    userInputFilterName: "companySize",
                    searchFilterItems: companySizeItems,
                    labelText: "Company Size"
                })}
                />
                <SearchFilter {...getFacetProps({
                    ...props,
                    fieldType: "checkbox",
                    disableOnCompanySelect: true,
                    userInputFilterName: "perks",
                    searchFilterItems: convertPerksAndBeniftsToNestedFormat(perks_and_benefits),
                    labelText: "Perks and Benefits"
                })}
                />
                <SearchFilter {...getFacetProps({
                    ...props,
                    fieldType: "checkbox",
                    disableOnCompanySelect: true,
                    userInputFilterName: "companyLeadership",
                    searchFilterItems: convertToFacetItemsFormat(diversity_and_inclusion_attributes),
                    labelText: "Diversity & Inclusion"
                })}
                />
            </div>
        </div>
    );
};

export default CompanyFacets;
